import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filteredLessonIds: [],
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilteredLessonIds: (state, action) => {
      state.filteredLessonIds = action.payload;
    },
    clearFilteredLessonIds: (state) => {
      state.filteredLessonIds = [];
    },
  },
});

export const { setFilteredLessonIds, clearFilteredLessonIds } = filtersSlice.actions;
export default filtersSlice.reducer;